import httpClient from "@/api/httpClient";
import { AxiosResponse } from "axios";

export const getAllGroups = async (): Promise<AxiosResponse> =>
  await httpClient.get(`/groups`);

export default getAllGroups;
